<template lang="pug">
  .reset-password
    .reset-password-form
      .site-logo
        span.site-name {{ $t('property_list_page.rent_assessment_system') }}
      .data-form(v-if="!passwordReseted")
        h2.title {{ $t('reset_password.reset_password') }}
        p.text {{ $t('reset_password.please_enter_email') }}
        hr.line
        p.input-label {{ $t('reset_password.email_address') }}
        input(v-model="email")
        b-button.reset-password-button(
          variant="primary"
          @click="resetPassword"
        ) {{ $t('reset_password.reset_password') }}
        p.errors {{ errors }}
      reseted-password(v-else)

</template>

<script>
  import { api } from '@/api.js'
  import ResetedPassword from '@/pages/Authentication/Password/Reset/reseted-password'
  import redirectLoggedUser from '@/mixins/redirect-logged-user'

  export default {
    components: {
      ResetedPassword
    },

    mixins: [redirectLoggedUser],

    data() {
      return {
        email: '',
        errors: '',
        passwordReseted: false
      }
    },

    computed: {
      resetPasswordUrl() {
        return `/passwords/reset_password`
      }
    },

    methods: {
      resetPassword() {
        this.errors = ''
        const params = { email: this.email }
        api.post(this.resetPasswordUrl, params).then(() => {
          this.email = ''
          this.passwordReseted = true
        }).catch(() => {
          this.errors = this.$t('reset_password.email_not_found')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .reset-password {
    background: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
    display: flex;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index: 999999;

    .reset-password-form {
      margin: auto;

      .site-logo {
        align-items: center;
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .site-name {
          color: #fff;
          font-size: 18px;
          letter-spacing: 0;
          opacity: 0.9;
        }
      }

      .data-form {
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 4px 16px 0 rgba(176, 186, 197, 0.56);
        padding: 50px;
        width: 445px;

        .title {
          margin-bottom: 30px;
          text-align: center;
        }

        .text {
          margin-bottom: 50px;
          text-align: center;
        }

        .input-label {
          font-weight: 700;
          margin: 30px 0 5px 0;
          text-transform: uppercase;
        }

        input {
          background: #fff;
          border: 1px solid #dfe6ee;
          border-radius: 4px;
          height: 40px;
          width: 100%;
        }

        .reset-password-button {
          background-image: linear-gradient(270deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
          border: 0;
          border-radius: 4px;
          color: #fff;
          font-size: 14px;
          height: 40px;
          letter-spacing: 0;
          margin: 20px 0 0 0;
          width: 100%;
        }

        .errors {
          color: red;
          margin-top: 20px;
        }
      }
    }
  }
</style>
